import React from 'react'
import Common_Css from './component/Common_Css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap';
import '../node_modules/jquery/dist/jquery';
import '../node_modules/slick-slider/slick/slick.css';
import '../node_modules/slick-slider/slick/slick-theme.css';
import '../node_modules/slick-slider/slick/slick.min.js';
import Home from './component/Home/Home';
import About from './component/About/About';
import ContactUs from './component/ContactUs/ContactUs';
//slick slider css
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as Icon from 'react-feather';
import GetaQuote from './component/GetaQuote/GetaQuote';
import Portfolio from './component/Portfolio/Portfolio';
import Career from './component/Career/Career';
import Services from './component/Services/Services';
import WebDevelopment from './component/TopServices/WebDevelopment/WebDevelopment';
import OutsourcingSoftwareDevelopment from './component/TopServices/OutsourcingSoftwareDevelopment/OutsourcingSoftwareDevelopment';
import CmsDevelopment from './component/TopServices/CmsDevelopment/CmsDevelopment';
import MobileAppDevelopment from './component/TopServices/MobileAppDevelopment/MobileAppDevelopment';
import DigitalMarketing from './component/TopServices/DigitalMarketing/DigitalMarketing';
import Erp from './component/TopServices/ERP/Erp';
import InternetOfThings from './component/TopServices/InternetOfThings/InternetOfThings';
import ScrollToTop from './ScrollToTop';
import MachineLearning from './component/TopServices/MachineLearning/MachineLearning';
import IVRServiceProvider from './component/TopServices/IVRServiceProvider/IVRServiceProvider';
import DotnetDevelopment from './component/TopServices/Dotnet-Development/DotnetDevelopment';
import Certificate from './component/Certificate/Certificate';
import PowerPoints from './component/PortfolioPages/PowerPoints/PowerPoints';
import CRMFixfella from './component/PortfolioPages/CRMFixfella/CRMFixfella';
import BluetoothMain from './component/PortfolioPages/BluetoothPage/BluetoothMain';
import MeseeProject from './component/PortfolioPages/MeseeProject/MeseeProject';
import JohnBullProject from './component/PortfolioPages/JohnBullProject/JohnBullProject';
import JunkRemoval from './component/PortfolioPages/JunkRemoval/JunkRemoval';
import DashGlobal from './component/PortfolioPages/DashGlobal/DashGlobal';
import KristaProject from './component/PortfolioPages/KristaProject/KristaProject';
import Term_home from './component/Term_Condition/Term_home'
import Analytic_code from './component/Analytic_code';
import Privacy_home from './component/Privacy_policy/Privacy_home';
import Refund_Home from './component/Refund_policy/Refund_Home';
import UnsubscribePage from './component/Unsubscribe_us/UnsubscribePage';
import BecomePartner from './component/Become_a_partner/BecomePartner';
import BecomePartnerForm from './component/Become_a_partner/BecomePartnerForm';

import ItServiceProvider from './component/ItServiceProvider/ItServiceProvider';
import ITServiceProviderCompanyDetails from './component/ItServiceProvider/ITServiceProviderCompanyDetails';
import ITServiceProviderCompanyContactPerson from './component/ItServiceProvider/ITServiceProviderCompanyContactPerson';
import ITServiceProviderCompanyBank from './component/ItServiceProvider/ITServiceProviderCompanyBank';
// import ITServiceProviderCompanyService from './component/ItServiceProvider/ITServiceProviderCompanyService';
import ITServiceProviderIndividualService from './component/ItServiceProvider/ITServiceProviderIndividualService';
import ITServiceProviderIndividualDetails from './component/ItServiceProvider/ITServiceProviderIndividualDetails';
import ITServiceProviderIndividualBank from './component/ItServiceProvider/ITServiceProviderIndividualBank';
import ITServiceProviderCompanyService1 from './component/ItServiceProvider/ITServiceProviderCompanyService1';
import ITServiceProviderCompanyService2 from './component/ItServiceProvider/ITServiceProviderCompanyService2';
import ITServiceProviderIndividualService1 from './component/ItServiceProvider/ITServiceProviderIndividualService1';
import Basic from './component/ItServiceProvider/Basic';
// import ITservice from './component/ITservice/ITservice';
// import MetaState from './Context/MetaState';
function App() {

  return (
    <>
      {/* <MetaState> */}
      <BrowserRouter>
        {/* <Analytic_code/> */}
        <ScrollToTop />
        <Routes>
          <Route path='/' exact element={<Home />}></Route>
          <Route path='/about-us' exact element={<About />}></Route>
          <Route path='/contact-us' exact element={<ContactUs />}></Route>
          <Route path='/portfolio' exact element={<Portfolio />}></Route>
          <Route path='/get-a-quote' exact element={<GetaQuote />}></Route>
          <Route path='/services' exact element={<Services />}></Route>
          <Route path='/career' exact element={<Career />}></Route>
          {/* Top Services */}
          <Route path='/web-development-company' exact element={<WebDevelopment />}></Route>
          <Route path='/mobile-app-development-company' exact element={<MobileAppDevelopment />}></Route>
          <Route path='/outsourcing-software-development-company' exact element={<OutsourcingSoftwareDevelopment />}></Route>
          <Route path='/cms-development-company' exact element={<CmsDevelopment />}></Route>
          <Route path='/erp-development-company' exact element={<Erp />}></Route>
          <Route path='/digital-marketing-company' exact element={<DigitalMarketing />}></Route>
          <Route path='/iot-app-development-company' exact element={<InternetOfThings />}></Route>
          <Route path='/machine-learning-solution' exact element={<MachineLearning />}></Route>
          <Route path='/ivr-services-provider-in-noida' exact element={<IVRServiceProvider />}></Route>
          <Route path='/dot-net-technology-development' exact element={<DotnetDevelopment />}></Route>
          <Route path='/certificate' exact element={<Certificate />}></Route>
          <Route path='/power-points' exact element={<PowerPoints />}></Route>
          <Route path='/crm-fixfella' exact element={<CRMFixfella />}></Route>
          <Route path='/bluetooth' exact element={<BluetoothMain />}></Route>
          <Route path='/mesee-project' exact element={<MeseeProject />}></Route>
          <Route path='/johnbull-project' exact element={<JohnBullProject />}></Route>
          <Route path='/junk-removal' exact element={<JunkRemoval />}></Route>
          <Route path='/dash-global' exact element={<DashGlobal />}></Route>
          <Route path='/krista-project' exact element={<KristaProject />}></Route>
          <Route path='/terms-and-conditions' exact element={<Term_home />}></Route>
          <Route path='/privacy-policy' exact element={<Privacy_home />}></Route>
          <Route path='/non-refundable-policy' exact element={<Refund_Home />}></Route>
          <Route path='/unsubscribe-us' exact element={<UnsubscribePage />}></Route>
          <Route path='/become-a-partner' exact element={<BecomePartner />}></Route>
          <Route path='/become-partner-form' exact element={<BecomePartnerForm />}></Route>

          <Route path='/it-service-provider' exact element={<ItServiceProvider />}></Route>

          <Route path='/it-service-provider-company-details' exact element={<ITServiceProviderCompanyDetails />}></Route>
          <Route path='/it-service-provider-company-contact-person-details' exact element={<ITServiceProviderCompanyContactPerson />}></Route>
          <Route path='/it-service-provider-company-bank-details' exact element={<ITServiceProviderCompanyBank />}></Route>
          <Route path='/it-service-provider-company-service-offered' exact element={<ITServiceProviderCompanyService1 />}></Route>
          <Route path='/it-service-provider-company-service-offered1' exact element={<ITServiceProviderCompanyService1 />}></Route>
          <Route path='/it-service-provider-company-service-offered2' exact element={<ITServiceProviderCompanyService2/>}></Route>

          <Route path='/it-service-provider-individual-basic-details' exact element={<ITServiceProviderIndividualDetails />}></Route>
          <Route path='/it-service-provider-individual-bank-details' exact element={<ITServiceProviderIndividualBank />}></Route>
          <Route path='/it-service-provider-individual-service-offered' exact element={<ITServiceProviderIndividualService1 />}></Route>
          <Route path='/it-service-provider-individual-service-offered1' exact element={<ITServiceProviderIndividualService1 />}></Route>
          {/* <Route path="/basic" exact element={<Basic/>}></Route> */}



          {/* <Route path='/it-service' exact element={<ITservice />}></Route> */}
        </Routes>
      </BrowserRouter>
      {/* </MetaState> */}
    </>
  );
}

export default App;
